import request from '@/utils/request'
import { download } from '@/utils/http'

const BASE_URL = 'system/asyncjob'

export const LIST_URL = `${BASE_URL}/list`

export function remove(idList: any) {
  return request({
    url: BASE_URL,
    method: 'delete',
    data: idList
  })
}

export function downloadFile(query: any) {
  return download(`${BASE_URL}/download`, query)
}
